var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiPass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 9.16667V2.5H12.5003V5H7.50033V2.5H1.66699V9.16667H7.50033V6.66667H9.16699V15H12.5003V17.5H18.3337V10.8333H12.5003V13.3333H10.8337V6.66667H12.5003V9.16667H18.3337ZM5.83366 7.5H3.33366V4.16667H5.83366V7.5ZM14.167 12.5H16.667V15.8333H14.167V12.5ZM14.167 4.16667H16.667V7.5H14.167V4.16667Z",
    fill: "#75748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiPass);
export default __webpack_public_path__ + "static/media/multiPass.d14dbac6715001a369e14f5b175ae049.svg";
export { ForwardRef as ReactComponent };